import { render } from "./CookieFreeZone.vue?vue&type=template&id=c158a316"
import script from "./CookieFreeZone.vue?vue&type=script&lang=js"
export * from "./CookieFreeZone.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benny\\Documents\\Programmieren\\Vue\\cellCalculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__